import React, { useEffect, useRef, useState } from "react";
import { Button } from "../../../../../shadcn/components/ui/button";
import { useSelector } from "react-redux";
import {
  getBidderByUuid,
  getDigioESignStatus,
  initiateDigioESign,
  updateBidderForEvent,
} from "services/bidder";
// import * as axios from "axios";
// import { webStore, clearAuth } from "store";
import SwitchToOfflineKycModal from "../SwitchToOfflineKycModal";
interface NIESignComponentProps {
  bidderUuid: any;
  bidder: any;
  stepsTitles: any;
  activeStep: any;
  setActiveStep: any;
  init: any;
  requestId: any;
}

export default function NIESignComponent({
  bidderUuid,
  init,
  bidder,
  activeStep,
  setActiveStep,
  requestId = null,
}: NIESignComponentProps) {
  const onboardingData = useSelector((state: any) => {
    return state.bidderAuth.onboarding;
  });
  const [loading, setLoading] = useState<any>(false);
  const [checkingStatus, setCheckingStatus] = useState<any>(false);
  const [isNavigated, setIsNavigated] = useState<any>(false);
  const [isSignPending, setIsSignPending] = useState<any>(false);
  const [switchToOfflineModalOpen, setSwitchToOfflineModalOpen] =
    useState(false);
  const [switchingToOffline, setSwitchingToOffline] = useState(false);
  const [isOnlineModeIssue, setIsOnlineModeIssue] = useState(false);
  const [isOpeningDigio, setIsOpeningDigio] = useState(false);
  const isDigioCallbackHandledRef = useRef(false);

  const [error, setError] = useState<any>("");
  useEffect(() => {
    const scriptId = "digio-sdk-script";

    // Check if script is already added
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.type = "text/javascript";
      script.src = "https://app.digio.in/sdk/v11/digio.js";
      script.async = true;

      document.body.appendChild(script);
      console.log("SCRIPT__INJECTED");

      // Cleanup function
      return () => {
        const existingScript = document.getElementById(scriptId);
        if (existingScript) {
          console.log("called");
          document.body.removeChild(existingScript);
        }
      };
    }
  }, [checkingStatus]);

  const handleRequestSigning = async () => {
    try {
      setError("");
      setIsOpeningDigio(true);
      isDigioCallbackHandledRef.current = false;
      // await getDigioESignStatus("DID2505191104277784VTEH2VLKJTGVJ");
      const res: any = await initiateDigioESign({
        bidder_onboarding_uuid: onboardingData.uuid,
        eligible_bidders_uuid: bidderUuid,
      });
      console.log("res:------ ", res, res.data.id);
      var options = {
        environment: process?.env?.NEXT_PUBLIC_DIGIO_ENVIRONMENT,
        callback: async function (response: any) {
          if (isDigioCallbackHandledRef.current) return;
          isDigioCallbackHandledRef.current = true;
          setLoading(true);
          if (response.hasOwnProperty("error_code")) {
            //check status of flow
            console.log("response---------->>>>", response);
            // return console.log("error occurred in process");
          }
          console.log("response---------->>>>", response);
          //check status of flow
          console.log("Signing;completed;successfully:");
          try {
            await init();
            setIsNavigated(false);
          } finally {
            setLoading(false);
          }
        },
        logo: process.env.NEXT_PUBLIC_IMAGIX_URL?.includes("staging")
          ? `${process.env.NEXT_PUBLIC_IMAGIX_URL}/24534319-e399-47f9-ad4c-f98d5d9bbbb3`
          : `${process.env.NEXT_PUBLIC_IMAGIX_URL}/fa4a3024-6d97-488b-88e0-a6f5d802b2ba`,
        is_redirection_approach: false,
        is_iframe: true,
        theme: {
          primaryColor: "#FF752C",
          secondaryColor: "#262626",
        },
      };
      // @ts-ignore
      var digio = new Digio(options);
      digio.init();
      digio.submit(
        res.data.id,
        bidder?.application_form_data?.ar_details?.user_mobile,
        res.data?.access_token?.id,
      );
      // Digio modal is requested; stop local loading state.
      setIsOpeningDigio(false);
      setIsNavigated(true);
    } catch (error) {
      console.log("error:====>>> ", error);
      setError(
        "Oops! Something went wrong. Please try again in a few moments.",
      );
      setIsOpeningDigio(false);
    }
  };

  useEffect(() => {
    if (!isNavigated && !requestId) return;
    (async () => {
      try {
        console.log("called=======>>>>1");
        setLoading(true);
        await new Promise((resolve) => setTimeout(resolve, 1000));
        const data: any = await getBidderByUuid(bidderUuid);
        const eSignRequestId = requestId || data?.esigned_data?.request_id;
        if (eSignRequestId) {
          setCheckingStatus(true);
          const payload = {
            eligible_bidders_uuid: bidderUuid,
            e_sign_request_id: eSignRequestId,
          };
          const res: any = await getDigioESignStatus(payload);
          console.log("res:======>>>> ", res);
          if (res?.data?.agreement_status === "completed") {
            const data: any = await getBidderByUuid(bidderUuid);
            await updateBidderForEvent({
              uuid: bidderUuid,
              meta: {
                ...data?.meta,
                submission_time: new Date().toISOString(),
                steps_status: {
                  ...data?.meta?.steps_status,
                  e_sign: "completed",
                  completed: "completed",
                },
              },
              digio_request_status: "approved",
              verification_step: "completed",
              status: "pending",
            });
            setActiveStep(activeStep + 1);
            await new Promise((resolve) => setTimeout(resolve, 1000));
            await init();
            setIsSignPending(false);
          } else {
            setIsSignPending(true);
            setIsOnlineModeIssue(true);
          }
          setCheckingStatus(false);
        }
      } catch (error) {
        console.log("error: ", error);
        setCheckingStatus(false);
        setIsOpeningDigio(false);
      } finally {
        setLoading(false);
      }
    })();
  }, [isNavigated, requestId, bidderUuid, activeStep, init, setActiveStep]);
  const handleSwitchToOffline = async () => {
    const isOfflineEnabled =
      process.env.NEXT_PUBLIC_ENABLE_OFFLINE_NI_KYC === "true";
    if (switchingToOffline && !isOfflineEnabled) return;

    setSwitchingToOffline(true);
    setSwitchToOfflineModalOpen(false);
    try {
      const data: any = await getBidderByUuid(bidderUuid);
      await updateBidderForEvent({
        uuid: bidderUuid,
        meta: {
          ...data?.meta,
          bid_application_flow_mode: "offline",
        },
      });
      // Reload the page to show offline KYC flow
      window.location.reload();
    } catch (error) {
      console.log("error switching to offline KYC: ", error);
      setSwitchingToOffline(false);
    }
  };
  const SwitchToOfflineKYCNotification = () => {
    return (
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-4 p-4 bg-blue-50 border-l-4 border-blue-500 rounded-md mt-4">
        <div className="flex items-start sm:items-center space-x-3 flex-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5 sm:mt-0"
          >
            <path
              fill="currentColor"
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
            />
          </svg>
          <div className="flex-1">
            <p className="text-blue-800 text-sm font-medium">
              Facing issues with Online KYC?
            </p>
            <p className="text-blue-700 text-xs mt-1">
              You can switch to Offline KYC mode by uploading your documents
              manually. Once done, fill out the auction participation form and
              submit it to the bank to complete your participation.
            </p>
          </div>
        </div>
        <Button
          onClick={() => setSwitchToOfflineModalOpen(true)}
          disabled={switchingToOffline}
          variant="outline"
          className="border-brand-headingBlue text-brand-headingBlue text-xs"
        >
          {switchingToOffline ? "Switching..." : "Switch to Offline Mode"}
        </Button>
      </div>
    );
  };
  if (loading) {
    return <CheckingESignStatus />;
  }
  const isOfflineEnabled =
    process.env.NEXT_PUBLIC_ENABLE_OFFLINE_NI_KYC === "true";

  return (
    <div className="py-4 bg-white rounded-lg mt-6">
      <p className="text-lg font-semibold text-gray-700">
        You need to complete E-sign to participate in the bidding process.
      </p>
      <div className="my-4">
        {isSignPending && !checkingStatus && <ESignPending />}
        {isOfflineEnabled && isOnlineModeIssue && (
          <SwitchToOfflineKYCNotification />
        )}
      </div>
      <p className="text-sm text-gray-600 mt-2">
        This secure digital signature process is powered by Digio and ensures
        that all your submitted documents are legally compliant and verifiable.
        Make sure your Aadhaar-linked mobile number is active to receive the OTP
        during signing.
      </p>
      <div className="mt-16 mb-10 md:mb-0">
        {error && <div className="text-sm text-brand-textRed">{error}</div>}
        <Button
          className="w-full max-w-xl h-10 text-base"
          onClick={handleRequestSigning}
          disabled={
            checkingStatus || Boolean(error) || isOpeningDigio || loading
          }
        >
          {isOpeningDigio || loading ? "Opening Digio..." : "Proceed"}
        </Button>
      </div>
      {switchToOfflineModalOpen && (
        <SwitchToOfflineKycModal
          open={switchToOfflineModalOpen}
          setOpen={setSwitchToOfflineModalOpen}
          handleConfirm={handleSwitchToOffline}
        />
      )}
    </div>
  );
}

const ESignPending = () => {
  return (
    <div className="flex items-center space-x-3 p-4 bg-yellow-100 border-l-4 border-yellow-500 rounded-md">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        className="w-6 h-6 text-yellow-600"
      >
        <circle
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeMiterlimit={10}
          cx={16}
          cy={16}
          r={12}
        />
        <rect x={15} y={14} width={2} height={8} fill="currentColor" />
        <rect x={15} y={10} width={2} height={2} fill="currentColor" />
      </svg>
      <p className="text-yellow-800 text-sm font-medium">
        Your E-sign process is incomplete. Please complete all required steps to
        proceed.
      </p>
    </div>
  );
};

const CheckingESignStatus = () => {
  return (
    <div className="flex items-center space-x-3 p-4 bg-blue-100 border-l-4 border-blue-500 rounded-md">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className="w-6 h-6 text-blue-600 animate-spin"
      >
        <circle
          cx="12"
          cy="12"
          r="10"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          fill="currentColor"
          d="M12 2a10 10 0 0 0-9 6h2a8 8 0 1 1 7 10V22a10 10 0 0 0 0-20z"
        />
      </svg>
      <p className="text-blue-800 text-sm font-medium">
        Checking your KYC status. Please wait...
      </p>
    </div>
  );
};
